import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../globalStore/store';
import { setPassword, setUserName } from '../../reducers/user/userSlice';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import userPool from '../../util/cognito/userPool';
import reqProvider from '../../util/requests/reqProvider';
import RegistrationLayout from '../../Components/layout/RegistrationLayout';
import KeyIcon from '@mui/icons-material/Key';
import { Button, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import RegistrationFormBox from '../../Components/layout/RegistrationFormBox';
import { useNotify } from '../../util/hooks/notify/Notification';
import CryptoJS from "crypto-js";
import { AxiosResponse } from 'axios';

const Login = () => {
  const userName: string = useSelector((state: RootState) => state.user.userName);
  const password: string = useSelector((state: RootState) => state.user.password);
  const dispatch: AppDispatch = useDispatch();
  const [showPassword, setShowPassword] = React.useState(false);
  const navigate = useNavigate();
  const notify = useNotify();

  const fetchData = async (url: string): Promise<AxiosResponse | undefined> => {
    try {
      return await reqProvider.get(url);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const inviteToken = new URLSearchParams(window.location.search).get('inviteToken');
    if (inviteToken) {
      localStorage.setItem('inviteToken', inviteToken);
    }
  },[])

  const encryptData = (data: object): string => {
    const SECRET_KEY : string | undefined = process.env.REACT_APP_ENCRYPTION_KEY
    const jsonString = JSON.stringify(data);
    if (!SECRET_KEY) {
        throw new Error("Environment variable REACT_APP_ENCRYPTION_KEY is not defined");
    }
    const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
    return encodeURIComponent(encrypted);
  }

  const login = async (redirect: string) => {
      const user: CognitoUser = new CognitoUser({ Username: userName, Pool: userPool });
      const authDetails: AuthenticationDetails = new AuthenticationDetails({ Username: userName, Password: password });

      user.authenticateUser(authDetails, {
          onSuccess: async (result) => {
           localStorage.setItem('token', result.getAccessToken().getJwtToken());
            try {
              const inviteToken = localStorage.getItem('inviteToken');
              if (inviteToken) {
                const response = await reqProvider.post("invitation/privilege", { "uuid": inviteToken });
                if (response.status === 200) {
                  localStorage.removeItem('inviteToken');
                  const encryptedData = encryptData({ userName, password, redirect });
                  const baseUrl = process.env.REACT_APP_OLD_URL as string;
                  const hash = '#/login';
                  const url = new URL(baseUrl);
                  window.location.href = `${url.origin}${url.pathname}${hash}?data=${encryptedData}`;
                }
              } else {
                const response: AxiosResponse | undefined = await fetchData('auth/me');
                if (response?.data.companies.length < 1) {
                  navigate('/companyRegistration')
                } else {
                  const encryptedData = encryptData({ userName, password, redirect });
                  const baseUrl = process.env.REACT_APP_OLD_URL as string;
                  const hash = '#/login';
                  const url = new URL(baseUrl);
                  window.location.href = `${url.origin}${url.pathname}${hash}?data=${encryptedData}`;
                }
              }
            } catch (error) {
              console.error('Hiba a titkosítás során:', error);
              notify('Hiba történt a bejelentkezés során.', 'error');
            }
          },
        onFailure: (err) => {
          console.error('Login failed:', err);
          notify('Hibás felhasználónév vagy jelszó.', 'error');
        }
      });
  }


  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <RegistrationLayout>
      <RegistrationFormBox text={"Bejelentkezés"} icon={<KeyIcon sx={{ fontSize: '30px', transform: 'rotate(90deg)' }} />}>
        {/*<Button variant={'outlined'} onClick={()=>{notify("google bejelntkezés","error")}}*/}
        {/*        startIcon={<GoogleIcon sx={{ color: 'black' }} />}>{'Bejelentkezek Google fiókkal'}</Button>*/}
        <hr style={{ width: '100%' }} />
        <TextField
          fullWidth
          name={'email'}
          type="email"
          value={userName}
          onChange={(e) => dispatch(setUserName(e.target.value))}
          autoComplete={'off'}
          label={'Email cím'}
        />
        <TextField
          label="Jelszó"
          variant="outlined"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          value={password}
          onChange={(e) => dispatch(setPassword(e.target.value))}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleTogglePassword}
                  edge="end"
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <Visibility />  : <VisibilityOff /> }
                </IconButton>
              </InputAdornment>
            ),
          }}
          autoComplete={'new-password'}
        />
        <Typography variant={'caption'} color={'textSecondary'}>{'Elfelejtettem a jelszavam. '} <Link style={{color: 'black'}} to={'/forgotPassword'}>{"Új jelszó igénylése itt"}</Link> </Typography>
        <Button variant={'contained'} color={'primary'}
                onClick={() => login('/dashboard')}>{'Bejelentkezek emaillel'}</Button>
        <hr style={{width: '100%'}}/>
        <Typography variant={'h6'} fontWeight={"lighter"} color={'textSecondary'}>{'Még nincs PinkPOS fiókod? '} </Typography>
        <Button variant={'contained'} sx={{backgroundColor: '#FCD9E8', borderRadius: '30px', textTransform: 'none', fontWeight: 'lighter', color: '#291520'}}
        onClick={() => navigate('/registration')}>
          {"Regisztrálok ingyen"}
        </Button>
      </RegistrationFormBox>
    </RegistrationLayout>
  );
};

export default Login;